module.exports = __webpack_public_path__ + "media/application/images/technology/secondary_nav/identifying-and-mapping-d021103c1c2ede36cf061e1d644ac64e.jpg";